import * as springroll from "springroll";
import {GoogleAnalytics} from "springroll-google-analytics-plugin";
import {Application} from "../Application";

export class AnalyticsManager {

    public static event(category: string, action: string, label?: string, value?: number) {
        console.info("[Analytics]", category, action, label ?? "", value ?? "");
        const analytics = Application.instance.springroll.getPlugin("GoogleAnalytics") as (GoogleAnalytics & springroll.ApplicationPlugin);
        if (analytics) {
            analytics.event(category, action, label, value);
        }
    }
}
